import { render, staticRenderFns } from "./Referidos.vue?vue&type=template&id=4baf8f3e"
import script from "./Referidos.vue?vue&type=script&lang=js"
export * from "./Referidos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports